module.exports = __webpack_public_path__ + "static/media/PC6-4.47d9a114.jpg";